import { render, staticRenderFns } from "./BelowPerformance.vue?vue&type=template&id=09f8d389"
import script from "./BelowPerformance.vue?vue&type=script&lang=js"
export * from "./BelowPerformance.vue?vue&type=script&lang=js"
import style0 from "./BelowPerformance.vue?vue&type=style&index=0&id=09f8d389&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports